<template>
  <div class="admin-table-block">
    <div class="table-toolbar">
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <div class="table-search"><i class="bi bi-search"></i><input v-model.trim="busqueda" type="search" placeholder="Buscar categoría por nombre..." @input="Filtro" /><button v-if="busqueda" type="button" @click="busqueda=''; Filtro()" aria-label="Limpiar"><i class="bi bi-x-lg"></i></button></div>
        <div class="page-size-control"><span>Mostrar</span><select v-model.number="itemsPerPage" @change="onPageSizeChange" class="form-select form-select-sm"><option v-for="size in pageSizeOptions" :key="size" :value="size">{{ size }}</option></select><span>registros</span></div>
      </div>
      <span class="toolbar-count">{{ totalRows }} resultado(s)</span>
    </div>

    <div class="table-responsive admin-table-wrap">
      <table class="table admin-table align-middle">
        <thead><tr>
          <th class="sortable-th order-col" @click="sortBy('catOrden')">Orden <i class="bi" :class="sortIcon('catOrden')"></i></th>
          <th class="sortable-th" @click="sortBy('catNombre')">Categoría <i class="bi" :class="sortIcon('catNombre')"></i></th>
          <th>Power BI</th><th>Detalle</th><th>Proyecto</th><th>Canal</th>
          <th class="sortable-th" @click="sortBy('audfechaActualizacion')">Última actualización <i class="bi" :class="sortIcon('audfechaActualizacion')"></i></th>
          <th class="actions-col">Acciones</th>
        </tr></thead>
        <tbody>
          <tr v-if="loading"><td colspan="8"><div class="table-state"><span class="spinner-border spinner-border-sm"></span><span>Buscando categorías...</span></div></td></tr>
          <tr v-else-if="!paginatedLista.length"><td colspan="8"><div class="table-state"><i class="bi bi-inbox"></i><span>No hay categorías para mostrar.</span></div></td></tr>
          <tr v-else v-for="lista in paginatedLista" :key="lista.idCategoria">
            <td class="order-cell"><span>{{ lista.catOrden }}</span></td>
            <td><div class="category-cell"><span class="row-icon"><i :class="lista.nomIcono || 'bi bi-bookmark'"></i></span><div><strong>{{ lista.catNombre }}</strong><small>{{ lista.nomModulo || 'Sin módulo' }}</small></div></div></td>
            <td><a v-if="lista.linkBI" :href="lista.linkBI" target="_blank" rel="noopener" class="powerbi-link" :title="lista.linkBI"><i class="bi bi-bar-chart"></i> Abrir enlace</a><span v-else class="muted-value">Sin enlace</span></td>
            <td><span class="detail-text" :title="lista.catDetalle">{{ lista.catDetalle || '-' }}</span></td>
            <td><span class="relation-text" :title="lista.nomProyecto">{{ lista.nomProyecto || '-' }}</span></td>
            <td><span class="relation-text" :title="lista.nomSubProyectos">{{ lista.nomSubProyectos || '-' }}</span></td>
            <td><span class="audit-text">{{ lista.audfechaActualizacion || lista.audfechaCreacion || '-' }}</span></td>
            <td><div class="row-actions">
              <button type="button" class="action-btn edit" title="Editar" @click="openEditModal(lista.idCategoria, lista.nomCategoria, lista.nomIcono, lista.idIcono, lista.nomModulo, lista.idModulo, lista.catOrden, lista.catDetalle, lista.linkBI)"><i class="bi bi-pencil-square"></i></button>
              <button type="button" class="action-btn copy" title="Copiar enlace" @click="copiarAlPortapapeles(lista.linkBI)"><i class="bi bi-copy"></i></button>
              <button type="button" class="action-btn delete" title="Eliminar" @click="eliminar(lista.idCategoria)"><i class="bi bi-trash3"></i></button>
            </div></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-bottom justify-content-end">
      <div class="pagination-compact"><button @click="currentPage=1" :disabled="currentPage===1"><i class="bi bi-chevron-double-left"></i></button><button @click="currentPage--" :disabled="currentPage===1"><i class="bi bi-chevron-left"></i></button><span>Página {{ currentPage }} de {{ totalPages }}</span><button @click="currentPage++" :disabled="currentPage>=totalPages"><i class="bi bi-chevron-right"></i></button><button @click="currentPage=totalPages" :disabled="currentPage>=totalPages"><i class="bi bi-chevron-double-right"></i></button></div>
    </div>

    <b-modal ref="editModal" centered title="Editar categoría" hide-footer hide-close-button dialog-class="modal-md-custom">
      <div class="edit-modal-content">
        <label class="modal-field-title">Selecciona un icono</label>
        <div class="modal-icon-picker"><button v-for="icon in icons" :key="icon.nomIcono" type="button" @click="selectIcon(icon.nomIcono, icon.idIcono)" :class="{selected:icon.nomIcono===selectedIcon}"><i :class="icon.nomIcono"></i></button></div>
        <div class="row g-3"><div class="col-12"><label class="form-label fw-semibold">Módulo</label><input v-model="editedIconNameModulo" type="text" class="form-control" disabled /></div><div class="col-12"><label class="form-label fw-semibold">Nombre de la categoría</label><input v-model.trim="editedIconName" type="text" class="form-control" /></div><div class="col-12"><label class="form-label fw-semibold">Detalle</label><textarea v-model.trim="catDetalle" class="form-control" rows="3" placeholder="Ingrese el detalle de la categoría"></textarea></div><div class="col-12"><label class="form-label fw-semibold">Link Power BI</label><input v-model.trim="editedIconNameBI" type="text" class="form-control" placeholder="https://app.powerbi.com/..." /></div><div class="col-12"><label class="form-label fw-semibold">Número de orden</label><input v-model.trim="editedNroDeOrden" type="number" class="form-control" /></div></div>
        <div class="modal-actions"><b-button variant="light" @click="closeEditModal">Cancelar</b-button><b-button variant="primary" @click="saveChanges"><i class="bi bi-check2"></i> Guardar cambios</b-button></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import tableUx from "@/mixins/tableUx";
import Swal from "sweetalert";
import Swal2 from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [tableUx],
  name: "PowerbyTablaCategoria",

  data() {
    return {
      itemsPerPage: 5,
      currentPage: 1,
      selectedIcon: "ninguno",
      icons: [],
      idCategoria: "",
      idModulo: "",
      idIcono: "",
      editedIconName: "",
      editedIconNameBI: "",
      editedIconNameModulo: "",
      editedNroDeOrden: "",
      busqueda: "",
      catDetalle: "",
      hayResultadosFiltrados: false,
      filtradoCategorias: [],
      loading: false,
    };
  },

  mounted() {
    this.idUsuario = localStorage.getItem("userId");
    this.axios.get("BIClientes/ListadoIconos").then((r) => {
      this.icons = r.data;
    });
  },

  computed: {
    ...mapGetters("acciones", ["ListaModulos", "ListaCategorias"]),

    listaActual() {
      return this.hayResultadosFiltrados ? this.filtradoCategorias : this.ListaCategorias;
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    paginatedLista() {
      return this.sortedRows(this.listaActual).slice(this.startIndex, this.startIndex + this.itemsPerPage);
    },
    totalRows() {
      return this.listaActual.length;
    },
    totalPages() {
      return Math.ceil(this.listaActual.length / this.itemsPerPage) || 1;
    },
  },

  methods: {
    ...mapActions("acciones", ["ListarCategorias"]),

    extraerPowerBIIds(link) {
      const match = (link || "").match(/groups\/([a-z0-9-]+)\/reports\/([a-z0-9-]+)/);
      return match ? { grupoid: match[1], reporteid: match[2] } : { grupoid: "", reporteid: "" };
    },

    Filtro() {
      this.currentPage = 1;
      clearInterval(this.timerInterval);

      if (!this.busqueda) {
        this.hayResultadosFiltrados = false;
        this.filtradoCategorias = [];
        this.loading = false;
        return;
      }

      const termino = this.busqueda;
      this.loading = true;
      const inicio = Date.now();

      this.axios
        .get(`BIClientes/BusquedaCategoria?busqueda=${termino}`)
        .then(({ data }) => {
          if (termino !== this.busqueda) return;
          this.filtradoCategorias = Array.isArray(data) ? data : (data?.datos || []);
          this.hayResultadosFiltrados = true;
        })
        .catch(() => {})
        .finally(() => {
          clearInterval(this.timerInterval);
          setTimeout(() => { this.loading = false; }, Math.max(0, 800 - (Date.now() - inicio)));
        });
    },

    async eliminar(id) {
      const { isConfirmed } = await Swal2.fire({
        icon: "warning", title: "¿Eliminar categoría?",
        text: "Solo se eliminará si no está asociada a ningún perfil o acceso.",
        showCancelButton: true, confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar", confirmButtonColor: "#dc3545",
      });
      if (!isConfirmed) return;
      try {
        const { data } = await this.axios.delete(`BIClientes/EliminarCategoria?idcategoria=${id}`);
        const ok = data === true || data?.eliminado || data?.success;
        if (!ok) throw new Error(data?.mensaje || "La categoría tiene asociaciones y no puede eliminarse.");
        await this.ListarCategorias();
        Swal2.fire({ icon: "success", title: "Categoría eliminada", text: data?.mensaje || "Eliminada correctamente." });
      } catch (e) {
        Swal2.fire({ icon: "info", title: "No se puede eliminar", text: e.response?.data?.mensaje || e.message || "No se pudo eliminar." });
      }
    },

    copiarAlPortapapeles(link) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(link || "");
      } else {
        const el = document.createElement("textarea");
        el.value = link;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
      Swal("Enlace copiado al portapapeles", "", "success");
    },

    openEditModal(idcategoria, nombre, icono, idIcono, nombreModulo, idModulo, orden, detalle, linkBi) {
      Object.assign(this, {
        idCategoria: idcategoria, idModulo, editedIconName: nombre,
        selectedIcon: icono, idIcono, editedIconNameModulo: nombreModulo,
        editedNroDeOrden: orden, catDetalle: detalle || "", editedIconNameBI: linkBi || "",
      });
      this.$refs.editModal.show();
    },

    closeEditModal() {
      Object.assign(this, { idModulo: "", editedIconName: "", idIcono: "" });
      this.$refs.editModal.hide();
    },

    saveChanges() {
      const { grupoid, reporteid } = this.extraerPowerBIIds(this.editedIconNameBI);
      const from = {
        idUsuario: this.idUsuario, idIcono: this.idIcono, idModulo: this.idModulo,
        idCategoria: this.idCategoria, catNombre: this.editedIconName,
        linkBi: this.editedIconNameBI, catOrden: this.editedNroDeOrden,
        catDetalle: this.catDetalle, reporteid, grupoid,
      };
      this.axios.put("BIClientes/ModificarCategoria", from).then(() => {
        Swal("Se realizó los cambios", "", "success");
        this.selectedIcon = "";
        this.ListarCategorias();
      });
      this.closeEditModal();
    },

    selectIcon(iconClass, id) {
      this.selectedIcon = iconClass;
      this.idIcono = id;
    },
  },
};
</script>

<style scoped>
.admin-table-block{padding:.8rem}.table-toolbar{display:flex;align-items:center;justify-content:space-between;gap:.75rem;margin-bottom:.65rem}.table-search{width:min(100%,420px);min-height:42px;display:flex;align-items:center;gap:.55rem;padding:0 .75rem;border:1px solid var(--qhatu-border);border-radius:10px;background:#fff}.table-search>i{color:#8294a8}.table-search input{flex:1;min-width:0;border:0;outline:0;background:transparent;font-size:.82rem}.table-search button{width:30px;height:30px;border:0;border-radius:8px;background:#eef3f8;color:#6b7e92}.toolbar-count{color:var(--qhatu-muted);font-size:.76rem}.admin-table-wrap{border:1px solid var(--qhatu-border);border-radius:12px;overflow:auto}.admin-table{min-width:1040px;margin:0}.admin-table thead th{padding:.58rem .65rem;background:#eef5f9;color:#385069;border:0;border-bottom:1px solid var(--qhatu-border);font-size:.68rem;text-transform:uppercase;letter-spacing:.02em;white-space:nowrap}.admin-table tbody td{padding:.48rem .65rem;border-color:#edf1f5;font-size:.72rem}.order-col,.order-cell{width:70px;text-align:center}.order-cell span{display:inline-grid;place-items:center;min-width:30px;height:28px;border-radius:8px;background:#f2f6fa;color:#456079;font-weight:750}.actions-col{width:175px;text-align:center}.category-cell{display:flex;align-items:center;gap:.55rem;min-width:240px}.category-cell>div{min-width:0}.category-cell strong{display:block;max-width:280px;color:#263c53;font-size:.75rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.category-cell small{display:block;color:var(--qhatu-muted);font-size:.66rem}.row-icon{width:30px;height:30px;flex:0 0 30px;display:grid;place-items:center;border-radius:8px;background:var(--qhatu-primary-soft);color:var(--qhatu-primary)}.powerbi-link{display:inline-flex;align-items:center;gap:.35rem;color:var(--qhatu-primary);text-decoration:none;font-weight:700;white-space:nowrap}.muted-value,.audit-text{color:#667b90;font-size:.68rem}.detail-text{display:block;max-width:220px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#556a7f}.row-actions{display:flex;justify-content:center;gap:.3rem}.action-btn{width:32px;height:32px;border:0;border-radius:8px;display:grid;place-items:center;background:#f1f5f9;color:#63778c}.action-btn.edit{background:#fff4d6;color:#b97900}.action-btn.active{color:#07845f}.action-btn.inactive{color:#c44b55}.action-btn.copy{color:#3f72aa}.action-btn.delete{color:#d84b57}.table-state{min-height:120px;display:flex;align-items:center;justify-content:center;gap:.55rem;color:var(--qhatu-muted)}.table-bottom{display:flex;align-items:center;justify-content:space-between;gap:.75rem;flex-wrap:wrap;padding-top:.65rem}.page-size-control{display:flex;align-items:center;gap:.4rem;color:var(--qhatu-muted);font-size:.75rem}.page-size-control select{width:70px;min-height:34px}.pagination-compact{display:flex;align-items:center;gap:.3rem}.pagination-compact button{width:34px;height:34px;border:1px solid var(--qhatu-border);border-radius:8px;background:#fff;color:var(--qhatu-primary)}.pagination-compact button:disabled{opacity:.4}.pagination-compact span{padding:0 .35rem;color:#516579;font-size:.75rem}.modal-field-title{display:block;margin-bottom:.5rem;font-weight:700}.modal-icon-picker{display:grid;grid-template-columns:repeat(8,1fr);gap:.4rem;max-height:145px;overflow:auto;margin-bottom:1rem}.modal-icon-picker button{height:38px;border:1px solid var(--qhatu-border);border-radius:8px;background:#fff}.modal-icon-picker button.selected{border-color:var(--qhatu-primary);background:var(--qhatu-primary-soft);color:var(--qhatu-primary)}.modal-actions{display:flex;justify-content:flex-end;gap:.5rem;margin-top:1rem}@media(max-width:575.98px){.admin-table-block{padding:.6rem}.table-toolbar{align-items:stretch;flex-direction:column}.table-search{width:100%}.toolbar-count{align-self:flex-end}.table-bottom{align-items:stretch;flex-direction:column}.pagination-compact{justify-content:center}.modal-icon-picker{grid-template-columns:repeat(6,1fr)}}
.admin-table { min-width: 1320px; }
.relation-text { display: block; min-width: 130px; max-width: 190px; overflow: hidden; color: #556a7f; text-overflow: ellipsis; white-space: nowrap; }
</style>
